const normalizeSelectionIds = ids => (Array.isArray(ids) ? new Set(ids) : new Set(ids || []));

const areSetsEqual = (left, right) => left.size === right.size && [...left].every(id => right.has(id));

export function resolveNextRowSelectionModel({ currentSelectionModel, newRowSelectionModel, selectablePatientIds }) {
  const currentIds = normalizeSelectionIds(currentSelectionModel?.ids);
  const nextIds = normalizeSelectionIds(newRowSelectionModel?.ids);
  const selectableIds = normalizeSelectionIds(selectablePatientIds);
  const filteredNextIds = new Set([...nextIds].filter(id => selectableIds.has(id)));

  const shouldClearHeaderToggleSelection =
    selectableIds.size > 0 && areSetsEqual(filteredNextIds, currentIds) && areSetsEqual(filteredNextIds, selectableIds);

  const finalIds = shouldClearHeaderToggleSelection ? new Set() : filteredNextIds;

  return {
    ...newRowSelectionModel,
    type: 'include',
    ids: finalIds
  };
}
